import { useQuery } from "./useApi.js";
import { languages } from "../api/languages.service.js";

export function useLanguages(edition?: string) {
  return useQuery(() => languages.getDistinct(edition), [edition]);
}
